/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Allocationamount_Error2Inputs */

const en_coinvestments_allocationamount_error2 = /** @type {(inputs: Coinvestments_Allocationamount_Error2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to update allocation amount`)
};

/**
* | output |
* | --- |
* | "Failed to update allocation amount" |
*
* @param {Coinvestments_Allocationamount_Error2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_allocationamount_error2 = /** @type {((inputs?: Coinvestments_Allocationamount_Error2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Allocationamount_Error2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_allocationamount_error2(inputs)
});
export { coinvestments_allocationamount_error2 as "coInvestments_allocationAmount_error" }